import { FC, useState } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import { NavigationCloseButton, NavigationHelpButton } from '@eneco/flows/components';
import { FlowRoute } from '@eneco/flows/types';
import { FlowNavigation } from '@eneco/flows/utils';
import { Box, Button, Stack } from '@eneco/sparky';
import { usePlaceholderContent } from '@sitecore/common';
import { NavigationRendering } from '@sitecore/types/Navigation';

import { FlowContextSme } from '../../context';

const MKBPath = '/mkb/';

export const Navigation: FC<{ routes: FlowRoute<FlowContextSme>[] }> = ({ routes }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { Navigation: { fields: textualData } = {} } = usePlaceholderContent<{ Navigation: NavigationRendering }>();

  return (
    <FlowNavigation
      routes={routes}
      backLinkLabel={textualData?.header?.previousStepText?.value ?? ''}
      progressIndicatorLabels={textualData?.header?.navigationSteps?.value?.enum || []}>
      <Stack direction="row" gap="1">
        <TrackedDialog
          title={textualData?.header?.helpDialog?.value?.title}
          trigger={<NavigationHelpButton label={textualData?.header?.helpDialog?.value?.triggerText ?? ''} />}>
          <Box paddingBottom="8">
            <RichText html={textualData?.header?.helpDialog?.value?.content} />
          </Box>
        </TrackedDialog>

        <NavigationCloseButton
          label={textualData?.header?.stopDialog?.value?.triggerText ?? ''}
          onClick={() => {
            setIsModalOpen(true);
          }}
        />
      </Stack>

      <TrackedDialog
        isOpen={isModalOpen}
        setOpen={setIsModalOpen}
        title={textualData?.header?.stopDialog?.value?.title}>
        <Stack direction="column" gap="2">
          <Box paddingBottom="8">
            <RichText html={textualData?.header?.stopDialog?.value?.content} />
          </Box>
          <Stack direction={{ initial: 'column', lg: 'row' }} gap="2" wrap>
            <Button
              onClick={() => {
                setIsModalOpen(false);
                window.location.href = MKBPath;
              }}>
              {textualData?.header?.stopDialog?.value?.submitButtonText}
            </Button>

            <TrackedDialog.Close asChild>
              <Button action="secondary">{textualData?.header?.stopDialog?.value?.cancelButtonText}</Button>
            </TrackedDialog.Close>
          </Stack>
        </Stack>
      </TrackedDialog>
    </FlowNavigation>
  );
};
